import { Outlet, Link, useLocation } from "react-router-dom";
import { useAuth, useUser } from "@trillion/auth";
import { AppSidebar } from "@trillion/ui/components/app-sidebar";
import { Blocks, LayoutGrid, Users } from "lucide-react";

const navItems = [
  { label: "Diagrams", href: "/dashboard", icon: LayoutGrid },
  { label: "Teams", href: "/teams", icon: Users },
  { label: "MCP setup", href: "/mcp", icon: Blocks },
];

// Authenticated app chrome. Auth context comes from the single AppAuthProvider in RootLayout
// (the old per-layout AuthProvider duplication is gone).
export function AppLayout() {
  const { logout } = useAuth();
  const user = useUser();
  const location = useLocation();

  const activeHref = navItems.find(
    (item) =>
      item.href === location.pathname ||
      (item.href !== "/" && location.pathname.startsWith(item.href))
  )?.href;

  const boardRole = user?.productRoles?.find((r) => r.product === "board")?.role;

  return (
    <div className="flex h-dvh min-w-0 overflow-hidden">
      <AppSidebar
        appName="Board"
        items={navItems}
        activeHref={activeHref}
        collapsible={false}
        LinkComponent={Link}
        user={
          user
            ? {
                name: user.displayName || user.email,
                email: user.email,
                role: boardRole,
              }
            : undefined
        }
        onLogout={() => logout()}
      />
      <main className="min-h-0 min-w-0 flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
